module.exports = __webpack_public_path__ + "assets/plus-icon.svg";